import React, { useState, useMemo, useContext } from "react";
import { Redirect, useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteCeecampaignMembership, downloadFile } from "services/ConfigServices";
import useMembershipsTable from "./useMembershipsTable.js";
import EditCEECampaignMembershipDialog from "./EditCEECampaignMembershipDialog";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { memberships } from "variables/markets";
import Chip from "@mui/material/Chip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import CEECampaignsContext from "context/CEECampaignsContext";

const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const Container = styled.div`
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.15);
  border-top: 4px solid rgba(255, 255, 255, 1);
  background-color: white;
  margin-top: -0.5px;
`;

const ExpandableContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 4rem 2rem;
`;
const ExpandableElement = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => props.marginleft};
`;

const ElementTitle = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const ElementData = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const ExpandableComponent = props => {
  const { data } = props;
  console.log(data);
  return (
    <Container>
      <ExpandableContainer>
        <ExpandableElement>
          <ElementTitle>{memberships.internalmembershipnumber} : </ElementTitle>
          <ElementData>{data.parameters?.internalmembershipnumber}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberships.contactname} : </ElementTitle>
          <ElementData>{data.parameters?.contactname}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberships.contactjob} : </ElementTitle>
          <ElementData>{data.parameters?.contactjob}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberships.company} : </ElementTitle>
          <ElementData>{data.parameters?.company}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberships.siret} : </ElementTitle>
          <ElementData>{data.parameters?.siret}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberships.phone} : </ElementTitle>
          <ElementData>{data.parameters?.phone}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberships.email} : </ElementTitle>
          <ElementData>{data.parameters?.email}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberships.address} : </ElementTitle>
          <ElementData>{data.parameters?.address?.description}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberships.comments} : </ElementTitle>
          <ElementData>{data.parameters?.comments}</ElementData>
        </ExpandableElement>
        <ExpandableElement>
          <ElementTitle>{memberships.description} : </ElementTitle>
          <ElementData>{data.parameters?.description}</ElementData>
        </ExpandableElement>
        {data.parameters?.associatedfiles && <ExpandableElement>
          <ElementTitle>{memberships.associatedfiles} : </ElementTitle>
          <ElementData>{data.parameters?.associatedfiles?.map((file, index) => (
            <Chip label={file.fileName} onClick={downloadGED(file.fileId, file.fileName)} />
          ))}</ElementData>
        </ExpandableElement>}
      </ExpandableContainer>
    </Container>
  );
};

const downloadGED = (fileId, fileName) => async () => {
  axios
    .get(
      downloadFile(fileId),
      {
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      }
    )
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      link.click();
    });
};


const useStyles = makeStyles(styles);

const RTMemberships = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const ceeadmin = permis.includes("cee_admin");
  const { gridState, refetch, setSelectedMemberships } = useMembershipsTable();
  const ceeCampaignContext = useContext(CEECampaignsContext);
  const { ceecampaign, setCeecampaign } = ceeCampaignContext;
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;
  const [open, setOpen] = useState(false);
  const [currentMember, setCurrentMember] = useState(null);

  let dataMembers = gridState.data;

  const classes = useStyles();

  const columns = [
    {
      name: "Nom du membre",
      selector: (row) => row.parameters.name,
      sortable: true,
      maxWidth: "13rem",
    },
    {
      name: "Périmètre",
      selector: (row) => row.parameters.groups,
      sortable: true,
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <GroupCell>
          <div>{groupInfoListById["" + row.parameters.groups]}</div>
        </GroupCell>
      ),
    },
    {
      name: memberships.contactname,
      selector: (row) => row.parameters.contactname,
      sortable: true,
      maxWidth: "13rem",
    },
    {
      name: "",
      sortable: false,
      width: "7rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Editer le membre">
              <Button
                onClick={editMember(row)}
                color={"warning"}
                className={classes.actionButton}
              >
                <EditIcon fontSize="large" />
              </Button>
            </Tooltip>
            {ceeadmin && (
              <Tooltip title="Supprimer le membre">
                <CustomDeleteButton
                  deleteTitle={"Suppression du membre"}
                  deleteSubTitle={`Êtes-vous sûr de vouloir supprimer le membre ${row.parameters.name}? Cette action supprimera toutes les données relatives à ce membre.`}
                  handleSupprimer={deleteCEECampaignMembershipFunction(row)}
                />
              </Tooltip>
            )}
          </div>
        </>
      ),
    },
  ];

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const editMember = (row) => async () => {
    let obj = dataMembers.find((o) => o.id === row.id);
    console.log(obj, row.id);
    if (obj) {
      setCurrentMember(obj);
      handleClickOpen();
    }
  }

  const deleteCEECampaignMembershipFunction = (row) => async () => {
    let obj = dataMembers.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteCeecampaignMembership(idSelected);
    axios
      .delete(url, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `Le membre ' ${obj.parameters.name} a été supprimée`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setSelectedMemberships(selection.selectedRows);
  };


  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucun membre à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        expandOnRowClicked
        expandableRows
        expandableRowDisabled={(row) => row.disabled}
        expandableRowsComponent={ExpandableComponent}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="sm"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          Modification d'un membre
        </CustomDialogTitle>
        <DialogContent dividers>
          <EditCEECampaignMembershipDialog
            membership={currentMember}
            closeModal={handleEditClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTMemberships;
